import { Component as VueComponent, defineComponent, h } from 'vue';

import PendingScreen from '@/components/screens/PendingScreen.vue';
import support from '@/config/support';
import { Status } from '@/store/interfaces/IdoState';
import { useIdoStore } from '@/store/store';
import getSessionData from '@/utils/getSessionData';

const FINAL_STATUSES = [
    Status.loading,
    Status.success,
    Status.finished,
    Status.transition,
];

export default function withInterview(Component: VueComponent) {
    // PRODUCT-26110 Phase 2B2 Task 5 batch 4: see withErrorHandler.ts's identical note --
    // `Vue.component(name, ...)` used only as a definition-object builder, never
    // registered/looked-up by name; `defineComponent` is the direct Vue 3 replacement.
    return defineComponent({
        mounted() {
            const status = useIdoStore().status;
            const storage = support.sessionStorage ? window.sessionStorage : null;
            const session = useIdoStore().session || getSessionData(storage);
            if (!FINAL_STATUSES.includes(status)) {
                useIdoStore().loadInterview(session);
            }
        },

        render() {
            const { status } = useIdoStore();
            return [ Status.success, Status.transition, Status.finished ].includes(status)
                ? h(Component)
                : h(PendingScreen, { fullscreen: true });
        },
    });
}
